import { render, staticRenderFns } from "./editRule.vue?vue&type=template&id=bed92f46&scoped=true&"
import script from "./editRule.vue?vue&type=script&lang=js&"
export * from "./editRule.vue?vue&type=script&lang=js&"
import style0 from "./editRule.vue?vue&type=style&index=0&id=bed92f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed92f46",
  null
  
)

export default component.exports